var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"header",attrs:{"title":_vm.activityTheme,"left-arrow":"","fixed":""},on:{"click-left":_vm.onClickLeft}}),_c('div',{staticClass:"form-box"},[(_vm.loaded)?_c('table-grid',{attrs:{"meta-id":"1","data-id":_vm.customerId,"hidden-fields":_vm.hiddenFields,"grouping":_vm.grouping}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }